import React from "react";
import i18n from "i18";

import AppView from "./AppView";
import { Box } from "@mui/material";

export default class Page404 extends AppView {
    renderView() {
        return (
            <Box className="flex1 flex centerH centerV font f28 w700">{i18n.t("pages.404")}</Box>
        );
    }
}